import { handlePostRequest } from '.';
import { moduleName } from '../../constants';
import { URI } from '../../constants/URI';
import { setAuth, setUser } from '../slices/authSlice';
import { store } from '../store';

export const loginUser = async (body) => {
    const res = await handlePostRequest(URI.login, body, {
        module: moduleName.LOGIN,
        loading: false
    });
    if (res?.ack) {
        store.dispatch(setAuth(res.token));
        store.dispatch(setUser({
            name: res?.name,
            email: res?.email,
            role: res?.type
        }));
    }
    return res;
};


export const registerUser = async (body) => {
    const res = await handlePostRequest(URI.register, body, {
        module: moduleName.REGISTER,
    });

    return res;
};